export const SHIPPING_ADDRESS_SWITCHER_MODAL_KEY = 'shipping-address-switcher'
